import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import './nav-internal-iframe.css';

const StyledCard = styled(Card)(({ theme }) => ({
  overflow: 'visible',
  backgroundColor: 'white',
  minHeight: '100%',
  padding: theme.spacing(2),
  boxSizing: 'border-box',
}));

const InternalContainer = (props) => (
  <StyledCard>
    {props.element}
  </StyledCard>
);

export default InternalContainer;
